import React from "react";

import { Column, Row } from "@/components/ui/flex";
import { cn } from "@/lib/utils";

import { SplashTyping, SplashTypingProps } from "./SplashTyping";
import { BRAND_NAME, loginLogo } from "../app-layout/consts";

interface SplashScreenProps {
  splashContent: SplashTypingProps["content"];
  onClick?: () => void;
  children: React.ReactNode;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({
  splashContent,
  onClick,
  children,
}) => {
  return (
    <Row flex className="h-full" onClick={onClick}>
      <Column
        className={cn(["bg-accent-secondary relative flex-1 overflow-hidden"])}
        style={{
          backgroundImage: "url('/bg/SaltBrand_Patterns-teal.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex h-full flex-col items-center justify-center gap-[3vw] px-[8vw]">
          <img src={loginLogo} alt={BRAND_NAME} className="w-[25vw]" />
          <div className="relative h-[4vw] w-full">
            <SplashTyping content={splashContent} />
          </div>
        </div>
      </Column>

      <Column flex className="bg-background-1 overflow-y-auto p-8">
        <div className="flex-1" />
        <div className="min-h-16" />

        {children}

        <div className="min-h-16" />
        <div className="flex-1" />
      </Column>
    </Row>
  );
};
